/*function addBannerCollection () {
  let totalList = $('ul.product-grid li').length;
  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  if(totalList > 9) {
    var randomNumber = getRandomNumber(2, 9);
  }

  if(totalList <= 9) {
    var randomNumber = getRandomNumber(2, totalList);
  }
  //console.log(randomNumber);

  let bannerTotal = $('.grid-banner').length;

  if(bannerTotal == 0) {
    let getWidth = $('ul.product-grid li.grid__item').css('width');
    $('ul.product-grid li.grid__item:nth-child('+ randomNumber +')')
      .before('<li class="grid-item grid-banner"><div><img src="https://cdn.shopify.com/s/files/1/0582/0668/3290/files/bfit-lab-tested.jpg?v=1698435973" alt="Lab Tested"></div></li>');
    $('li.grid-collection-banner').css({'width': getWidth});
  }
}

$(window).on('load', function() {
  addBannerCollection();
});

$(window).on('resize', function() {
  addBannerCollection();
});*/

$('.dropdown-trigger').click(function() {
  let getID = $(this).attr('id');
  let status = $(this).attr('data-open');

  if(status == "true") {
    $(this).attr('data-open', 'false');
    $('[data-id="'+ getID +'"]').removeClass('open');
    $(this).find('.icon-minus').hide();
    $(this).find('.icon-plus').show();
  } else {
    $(this).attr('data-open', 'true');
    $('[data-id="'+ getID +'"]').addClass('open');
    $(this).find('.icon-plus').hide();
    $(this).find('.icon-minus').show();
  }
});


$(document).ready(function() {
  $('video').click(function() {
    this[this.paused ? 'play' : 'pause']();
    $(this).parent('.item-video').find('.icon-container .icon').toggleClass('active');
    $(this).parent('.item-video').find('.icon-container').toggleClass('hide');
  });

  $('.icon-play').click(function() {
    let parent = $(this).parent().parent();
    let vd = $(this).parent().parent().find('video');
    vd.get(0).play();
    parent.find('.icon-container .icon').toggleClass('active');
    parent.find('.icon-container').toggleClass('hide');
  });

  $('.icon-pause').click(function() {
    let parent = $(this).parent().parent();
    let vd = $(this).parent().parent().find('video');
    vd.get(0).pause();
    parent.find('.icon-container .icon').toggleClass('active');
    parent.find('.icon-container').toggleClass('hide');
  });
});

$('.product-form__submit').on('click', function() {
//$('.header__icon--cart').on('click', function() {
  setTimeout(function() {
    window.upcartRefreshCart();
  }, 200);
});


document.addEventListener('DOMContentLoaded', function() {
  const reviewsContainer = document.querySelector('.reviews-container');
  if(reviewsContainer) {
    reviewsContainer.id = 'resenas';
    reviewsContainer.classList.add('scrollcheck');
  }
  
  // Scroll and tab switching for elements with the class "scrollon"
  document.querySelectorAll('.scrollon').forEach(function(scrollon) {
      scrollon.addEventListener('click', function(event) {
        event.preventDefault();

        var target = document.querySelector(this.getAttribute('data-href'));
        var target_id = this.getAttribute('data-id');
        var offsetSpace = 0;

        if (target_id === 'como-consumir') {
          document.querySelectorAll('details').forEach(function(el) {
            el.removeAttribute('open', '');
          });
          document.querySelectorAll('#como-consumir').forEach(function(el) {
            el.setAttribute('open', '');
          });
        }

        if (target_id === 'ingredientes') {
          document.querySelectorAll('details').forEach(function(el) {
            el.removeAttribute('open', '');
          });
          document.querySelectorAll('#ingredientes').forEach(function(el) {
            el.setAttribute('open', '');
          });
        }


        setTimeout(function() {
          if (window.innerWidth > 1080) {
            offsetSpace = target.offsetTop + 10;
          } else {
            offsetSpace = target.offsetTop - 10
          }

          if (target) {
            window.scrollTo({
              top: offsetSpace,
              behavior: 'smooth'
            });
          }
        }, 100);

        // Tab switching logic
        

        if (target_id === 'cta-use') {
            document.querySelectorAll('#ingredientes-y-uso .product-simple-tab-header-wrapper, #ingredientes-y-uso .product-simple-tab-content').forEach(function(el) {
                el.classList.remove('active');
            });
            document.querySelectorAll('[data-tab-modo-de-uso], [data-content-modo-de-uso]').forEach(function(el) {
                el.classList.add('active');
            });
        }

        if (target_id === 'cta-details') {
            document.querySelectorAll('#detalles .product-section-tab-header-wrapper, #detalles .product-section-tab-content').forEach(function(el) {
                el.classList.remove('active');
            });
            document.querySelectorAll('[data-tab-detalles], [data-content-detalles]').forEach(function(el) {
                el.classList.add('active');
            });
        }
      });
  });

  // Select all sections with an id attribute
  const sections = document.querySelectorAll('.scrollcheck[id]');
  
  // Function to add 'active' class to the first matching data-href element
  function onScroll() {
    let currentSectionId = '';
    
    sections.forEach(section => {
      const sectionTop = section.offsetTop - 50; // Adjust based on your preference
      const sectionHeight = section.offsetHeight;
      
      if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
        currentSectionId = '#' + section.getAttribute('id');
      }
    });
    
    // Remove 'active' class from all data-href elements
    document.querySelectorAll('[data-href-mob]').forEach(link => {
      link.classList.remove('active');
      link.classList.remove('active-force');
    });
    
    // Add 'active' class to the first element with matching data-href-mob
    if (currentSectionId) {
      const firstMatch = document.querySelector(`[data-href-mob="${currentSectionId}"]`);
      if (firstMatch) {
        firstMatch.classList.add('active');
        document.querySelectorAll('[data-href-mob]').forEach(link => {
          link.classList.remove('active-force');
        });
      }
    }
  }
  
  window.addEventListener('scroll', onScroll);


  /*********************************/

  let lastScrollTop = 0;
  window.addEventListener('scroll', function() {
    const mainProductNavMobile = document.querySelector('.main-product-nav-mobile');
    const shopifyHeader = document.getElementById('shopify-section-header');
    const headerHeight = shopifyHeader.offsetHeight; // Obtener la altura del header
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if(mainProductNavMobile) {
      mainProductNavMobile.style.transition = 'top 0.3s ease';

      if (scrollTop > 200) {
        if (scrollTop > lastScrollTop) {
          // Scroll hacia abajo
          mainProductNavMobile.classList.add('scrolldown');
          mainProductNavMobile.classList.remove('scrollup');
          mainProductNavMobile.style.top = '0px';
        } else {
          // Scroll hacia arriba
          mainProductNavMobile.classList.add('scrollup');
          mainProductNavMobile.classList.remove('scrolldown');
          mainProductNavMobile.style.top = (headerHeight - 1) + 'px'; // Asignar la altura del header como 'top'
        }
      } else {
        // Si la posición del scroll es menor a 200
        mainProductNavMobile.classList.remove('scrolldown', 'scrollup');
        mainProductNavMobile.style.top = ''; // Quitar el estilo 'top' si no está en scroll down
        mainProductNavMobile.style.top = '0px';
      }

      lastScrollTop = scrollTop;
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Seleccionar todos los formularios de "Add to Cart"
  const forms = document.querySelectorAll('.add-to-cart-form');

  forms.forEach(form => {
    form.addEventListener('submit', function(event) {
      event.preventDefault(); // Evitar la recarga de la página
      
      // Obtener el id de la variante seleccionada
      const variantId = form.querySelector('input[name="id"]:checked')?.value || form.querySelector('input[name="id"]').value;
      const formData = new FormData();
      formData.append('id', variantId);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Manejar la respuesta exitosa
        console.log('Producto agregado al carrito:', data);
        // Aquí puedes actualizar el carrito, mostrar un mensaje de éxito, etc.
      })
      .catch(error => {
        console.error('Hubo un problema con la solicitud de agregar al carrito:', error);
        // Puedes manejar errores aquí
      });
    });
  });
});


function formatCurrency(amount) {
  let amountStr = amount.toString();
  let decimals = amountStr.slice(-2);
  let integerPart = amountStr.slice(0, -2);

  let formattedIntegerPart = '';
  let count = 0;
  for (let i = integerPart.length - 1; i >= 0; i--) {
    formattedIntegerPart = integerPart[i] + formattedIntegerPart;
    count++;
    if (count % 3 === 0 && i !== 0) {
      formattedIntegerPart = ',' + formattedIntegerPart;
    }
  }

  let formattedAmount = '$ ' + formattedIntegerPart + '.' + decimals;
  return formattedAmount;
}


//$('.label-card-variant').click(function() {
$(document).on('click', '.label-card-variant', function() {
  let title = $(this).data('title');
  let discountTag = $(this).data('discount');
  let getPrice = $(this).data('price');
  let getComparePrice = $(this).data('compare-price');
  let percentage = (100 - discountTag) / 100;
  let cleanPrice = getPrice.replace(/[.,$ ]/g, '').replace(/MXN/g, '');
  cleanPrice = cleanPrice * 1;
  let discountedPrice = cleanPrice * percentage;
  let amountSaving = null;
  let productId = $(this).data('product');

  $('.variant-' +  productId + ' .variant-value').text(title);

  if(discountTag !== null || discountTag !== '') {
    if(cleanPrice > discountedPrice) {
      amountSaving = cleanPrice - discountedPrice;
      $('.price-' +  productId).html('<div class="price"><div class="price__container"><div class=price__discount-tag><span class="visually-hidden visually-hidden--inline">Precio habitual</span> <span class="price-item italic text-price price-item--regular price-item-tag"style=font-weight:100>'+ formatCurrency(discountedPrice) +' MXN </span></div><div class=price__discounted><span class="visually-hidden visually-hidden--inline">Precio habitual</span> <span class="price-item italic text-price price-compare-tag"style=font-weight:100>'+ formatCurrency(cleanPrice) +'</span><span class="price-item price-item--last price-saving">Ahorra ' + formatCurrency(amountSaving) +'</span></div></div></div>');
    }
  } else {
    if(getComparePrice > cleanPrice) {
      amountSaving = getComparePrice - cleanPrice;
      $('.price-' +  productId).html('<div class="price"><div class="price__container"><div class=price__discount-tag><span class="visually-hidden visually-hidden--inline">Precio habitual</span> <span class="price-item italic text-price price-item--regular price-item-tag"style=font-weight:100>'+ formatCurrency(cleanPrice) +' MXN </span></div><div class=price__discounted><span class="visually-hidden visually-hidden--inline">Precio habitual</span> <span class="price-item italic text-price price-compare-tag"style=font-weight:100>'+ formatCurrency(getComparePrice) +'</span><span class="price-item price-item--last price-saving">Ahorra ' + formatCurrency(amountSaving) +'</span></div></div></div>');
    }
  }

});
